<!-- eslint-disable vue/require-v-for-key -->
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Multiselect from 'vue-multiselect'
import { Helper, debounce } from '@/mixin/helper'
import { required, minLength } from 'vuelidate/lib/validators'
import {
  DEVICE_MUTATION_DELETE,
  DEVICE_MUTATION_UPDATE,
  GET_DEVICE_CODE,
} from '@/services/api/master/tracking'
import { GET_COMPANYS } from '@/services/api/master/companies'
import { mapGetters } from 'vuex'
import { getVSMSRestClient } from '@/services/vsms'
import { getToolsClient } from '@/services/tools'
import McButton from '@/components/McButton'
import { getSmsClient } from '@/services/sms'
import * as vehicleApi from '@/services/rest-api-tools/lib/vehicle/vehicle'
import * as vehicleSmsApi from '@/services/rest-api-sms/lib/vehicle/vehicle'
import { isIndonesianPhoneNumber } from '@/helpers/validators'
import * as deviceApi from '@/services/rest-api-sms/lib/device/device'
import ImeiFilter from './components/ImeiFilter'
import SyncIccidLog from '@/router/views/master/tracking/Tracking/SyncIccidLog.vue'

const vsmsAxios = getVSMSRestClient()
const toolsAxios = getToolsClient()
const smsAxios = getSmsClient()

export default {
  page: {
    title: 'Registrasi Perangkat',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  components: {
    Layout,
    PageHeader,
    Multiselect,
    McButton,
    ImeiFilter,
    SyncIccidLog,
  },

  apollo: {
    companies: {
      query: GET_COMPANYS,
    },
    deviceTypes: {
      query: GET_DEVICE_CODE,
    },
  },

  mixins: [Helper],
  props: {
    formErrors: {},
  },

  data() {
    return {
      filterApi: {
        deviceTypes: null,
        status: null,
        orderBy: [JSON.stringify({ imei: 'asc' })],
        devicetype: {
          devicetype: [],
        },
      },
      selected: {
        tracking: [],
        listHistory: [],
        lastData: [],
        portKernel: 6000,
      },
      selectedModel: {
        tracking: [],
        listHistory: [],
        lastData: [],
      },
      allSelected: {
        tracking: false,
        listHistory: false,
        lastData: false,
      },
      indeterminate: {
        tracking: true,
        listHistory: true,
        lastData: false,
      },
      filterMonth: '',
      license_plat: null,
      lokasi: null,
      fav: null,
      vendor: null,
      tipePerangkat: null,
      filterHistory: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      totalPages: 0,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      appliedImeiFilters: [],
      selectedIccidStatusFilter: null,
      iccidStatusSummary: {
        total_data: 0,
        total_valid: 0,
        total_invalid: 0,
        iccid_not_found: 0,
      },
      filterRiwayat: null,
      filterOn: [],
      sortBy: 'imei',
      sortDesc: false,
      isEdit: false,
      responseModal: {
        title: 'Registrasi IMEI Berhasil',
        imei: null,
        vehicleId: null,
        status: null,
      },
      set: {
        imei: '',
        companies: null,
        phoneNo: '',
        iccid: null,
        vendorType: '',
        deviceName: '',
        odometer: null,
        vehicleYear: null,
        vehicleId: null,
        selectedVehicle: null,
        selectedVehicleType: null,
        hullNo: null,
        workOrderNumber: null,
        notes: null,
      },
      // Vehicles data
      vehicles: [],

      // Vehicle Types data
      vehicleTypes: [],

      form: {
        deviceTypes: null,
        companyId: 1,
        imei: null,
        phoneNo: null,
        iccid: null,
        vehicleId: null,
      },
      formOld: {
        deviceTypes: null,
        companyId: 1,
        imei: null,
        phoneNo: null,
        iccid: null,
        vehicleId: null,
      },
      show_model: null,
      show: [
        { key: 'imei', label: 'Imei' },
        { key: 'identifier', label: 'ID Pelacak' },
        { key: 'lat', label: 'Latitude' },
        { key: 'lon', label: 'Longitude' },
        { key: 'acc', label: 'Acc' },
        { key: 'speed', label: 'Speed' },
        { key: 'baterai', label: 'Baterai' },
        { key: 'date', label: 'Terakhir Update' },
        { key: 'status', label: 'Status' },
      ],
      isAddFavorit: false,
      addFavorit: null,
      showModal: false,
      titleModal: 'Registrasi IMEI',
      deviceTypes: {
        deviceType: [],
      },
      companies: {
        companies: [],
      },
      vehicleStatuses: {
        vehicleStatuses: [],
      },

      formStatus: 'create',
      status: '',
      sensors: [],

      tData: {
        listHistory: [
          {
            id: '1',
            columnFleet: 'M 4123 GU',
            columnImei: '894288282472824',
            columnNoTelp: '089534454535',
            columnStartTime: '28 Mar 2022',
            columnEndTime: '28 Apr 2022',
            type: 'data',
          },
          {
            id: '2',
            columnFleet: 'P 7877 QO',
            columnImei: '909320229482943',
            columnNoTelp: '081343948243',
            columnStartTime: '27 Jan 2022',
            columnEndTime: '27 Feb 2022',
            type: 'data',
          },
          {
            id: '3',
            columnFleet: 'L 1290 MC',
            columnImei: '777748474848847',
            columnNoTelp: '088938428348',
            columnStartTime: '01 Jan 2022',
            columnEndTime: '28 Jan 2022',
            type: 'data',
          },
        ],
      },
      filteredItems: [],
      isLoading: false,
      syncIccidLogModal: false,
      saveLoading: false,
      isCheckingIccid: false,
      iccidCheckStatus: null,
      iccidCheckResult: null,
      showDeviceType: false,
      vehicleYear: null,
      debounceTimer: null,
      accordionVisible: false,

      lastVehicleSearch: '',
    }
  },

  validations: {
    form: {
      deviceTypes: { required },
      imei: { required },
      phoneNo: { required, isIndonesianPhoneNumber },
    },
    set: {
      companies: { required },
      selectedVehicle: { required },
      selectedVehicleType: { required },
      phoneNo: { required, isIndonesianPhoneNumber },
      odometer: { required },
      workOrderNumber: { required },
      notes: { required, minLength:  minLength(10) },
    },
  },

  computed: {
    title() {
      return 'Registrasi IMEI'
    },

    visibleFields() {
      if (this.show_model && this.show_model.length > 0) {
        var result = this.show_model.map((a) => a.key)
        return this.tracking.filter(function (item) {
          return item.key == 'check' || result.includes(item.key)
        })
      } else {
        return this.tracking
      }
    },

    lastdataFields() {
      if (this.show_model && this.show_model.length > 0) {
        var result = this.show_model.map((a) => a.key)

        return this.lastData.filter(function (item) {
          return item.key == 'check' || result.includes(item.key)
        })
      } else {
        return this.lastData
      }
    },

    totalTrue() {
      return this.selectedModel.tracking.filter((c) => c === true)
    },

    tracking() {
      return [
        {
          key: 'vehicle.imei',
          label: this.$t('master.list.tracker.imei'),
          sortable: true,
        },
        {
          key: 'vehicle.device.phone_no',
          label: 'Nomor SIMCard',
          sortable: true,
          thStyle: {
            width: '240px',
            whiteSpace: 'nowrap',
          },
          tdStyle: {
            width: '300px',
            minWidth: '300px',
            whiteSpace: 'nowrap',
          },
        },
        {
          key: 'vehicle.device.iccid',
          label: 'Iccid',
          sortable: true,
        },
        {
          key: 'license_plate',
          label: 'ID Pelacak',
          sortable: true,
        },
        {
          key: 'vehicle.device.device_name',
          label: 'Tipe Perangkat',
          sortable: true,
        },
        {
          key: 'vehicle.device.port_kernel',
          label: 'Port',
          sortable: true,
        },
        {
          key: 'vehicle.device.vendor_type',
          label: 'Penyedia',
          sortable: true,
        },
        {
          key: 'latitude',
          label: this.$t('vehicle.status.latitude'),
          sortable: true,
        },
        {
          key: 'longitude',
          label: this.$t('vehicle.status.longitude'),
          sortable: true,
        },
        {
          key: 'speed',
          label: this.$t('vehicle.status.speed'),
          sortable: true,
        },
        {
          key: 'engine_on',
          label: this.$t('vehicle.status.ignition'),
          sortable: true,
          formatter: (value) => {
            switch (value) {
              case true:
                return this.$t('global.on')
              default:
                return this.$t('global.off')
            }
          },
        },
        {
          key: 'battery',
          label: this.$t('vehicle.status.battery'),
          sortable: true,
        },
        {
          key: 'last_receive',
          label: this.$t('vehicle.status.lastReceive'),
          sortable: true,
        },
        {
          key: 'last_position_status',
          label: this.$t('vehicle.status.lastStatusChg'),
          sortable: true,
        },
        {
          key: 'vehicle.status',
          label: this.$t('vehicle.status.motionStatus'),
          formatter: (value) => {
            switch (value) {
              case 'A':
                return this.$t('vehicle.motionStatus.assisted')
              case 'I':
                return this.$t('vehicle.motionStatus.idle')
              case 'P':
                return this.$t('vehicle.motionStatus.parked')
              case 'O':
                return this.$t('vehicle.motionStatus.offline')
              case 'M':
                return this.$t('vehicle.motionStatus.inMotion')
              default:
                return this.$t('vehicle.motionStatus.unknown')
            }
          },
          sortable: true,
        },
        {
          key: 'syncIccid',
          label: 'Sync Iccid',
          sortable: false,
        },
        {
          key: 'setCustomer',
          label: 'Daftarkan perangkat',
          sortable: false,
        },
      ]
    },

    lastData() {
      return [
        {
          key: 'imei',
          label: 'IMEI',
          sortable: true,
        },
        {
          key: 'date',
          label: 'Tanggal',
          sortable: true,
        },
        {
          key: 'lat',
          label: 'Latitude',
          sortable: true,
        },
        {
          key: 'lon',
          label: 'Longitude',
          sortable: true,
        },
        {
          key: 'acc',
          label: 'Acc',
          sortable: true,
        },
        {
          key: 'speed',
          label: 'Speed',
          sortable: true,
        },
        {
          key: 'batre',
          label: 'Baterai',
          sortable: true,
        },
      ]
    },

    listHistory() {
      return [
        {
          key: 'columnFleet',
          label: 'Kendaraan',
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'columnImei',
          label: 'IMEI',
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'columnNoTelp',
          label: 'Nomor Telepon',
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'columnStartTime',
          label: 'Waktu Awal',
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'columnEndTime',
          label: 'Waktu Akhir',
          thClass: 'mc-table--50',
          sortable: true,
        },
      ]
    },

    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
      getFeatureFlagData: 'identity/getFeatureFlagData',
    }),

    filteredVehicleTypes() {
      return [...this.vehicleTypes]
    },

    filteredVehicles() {
      return [...this.vehicles]
    },

    isDeviceStatusProcessActive() {
      return this.getFeatureFlagData('device_status_process').value
    },

    iccidStatusFilters() {
      return [
        {
          value: null,
          label: 'Semua',
          icon: null,
          variant: 'total',
        },
        {
          value: 'valid',
          label: 'Valid',
          icon: 'fas fa-check-circle',
          variant: 'valid',
        },
        {
          value: 'invalid',
          label: 'Tidak valid',
          icon: 'fas fa-exclamation-triangle',
          variant: 'invalid',
        },
        {
          value: 'iccid_not_found',
          label: 'Belum ada ICCID',
          icon: 'icon-outline_minus-circle',
          variant: 'missing',
        },
      ]
    },
  },

  async created() {
    await this.$v.set.$touch()
    await Promise.all([this.getVehicleStatus(), this.getIccidStatusSummary()])
  },

  methods: {
    async onVehicleSelect(vehicle) {
      const params = {
        filters: [`company_id eq 1`],
        limit: 1,
      }
      const responseLimit1 = await vehicleApi.getVehicleType(params)
      const totalCount = responseLimit1.metadata.total_count
      params.limit = totalCount
      const response = await vehicleApi.getVehicleType(params)
      const vehicleTypes = response.data.paginated_result
      this.vehicleTypes = vehicleTypes
      this.set.odometer = vehicle.odometer / 1000
      if (vehicle.vehicle_type_id) {
        this.set.selectedVehicleType = this.vehicleTypes.find(
          (data) => data.vehicle_type_id === vehicle.vehicle_type_id
        )
      }
      this.set.hullNo = vehicle.hull_no
    },

    async onCompanySelect(company) {
      const params = {
        filters: [`company_id eq ${company.id}`, `imei is null`],
        limit: 1,
      }
      const responseLimit1 = await vehicleApi.getVehicleUnregistered(params)
      const totalCount = responseLimit1.metadata.total_count
      params.limit = totalCount
      const response = await vehicleApi.getVehicleUnregistered(params)
      const vehicles = response.data.paginated_result
      this.vehicles = vehicles
    },

    async getVehicleStatus() {
      this.isLoading = true
      const params = {
        page: this.currentPage,
        limit: this.perPage,
        search: this.filter,
        sorts: 'vehicle_id desc',
        filters: [],
      }

      const imeiFilter = this.buildImeiFilter(this.appliedImeiFilters)
      if (imeiFilter) params.filters.push(...imeiFilter)

      if (this.selectedIccidStatusFilter) params.filters.push(`iccid_status eq '${this.selectedIccidStatusFilter}'`)

      const res = await vsmsAxios.get('/vehicle-status', { params }).catch((error) => {
        this.handleError(error)
        this.isLoading = false
      })
      if (!res) return

      this.filteredItems = res.data.data.paginated_result
      this.vehicleStatuses.vehicleStatuses = res.data.data.paginated_result
      this.totalRows = res.data.metadata.total_count
      this.totalPages = res.data.metadata.total_page
      this.isLoading = false
    },

    async getIccidStatusSummary() {
      const params = {
        search: this.filter,
      }

      const res = await vsmsAxios
        .get('/vehicle-status/summary/iccid', { params })
        .catch((error) => {
          this.handleError(error)
        })

      if (!res) return

      this.iccidStatusSummary = {
        ...this.iccidStatusSummary,
        ...res.data.data.paginated_result,
      }
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    addDevice() {
      this.isEdit = false
      this.showDeviceType = true
      this.form = {
        deviceTypes: '',
        companyId: 1,
        imei: '',
        phoneNo: '',
        iccid: null,
      }

      this.formStatus = 'create'
      this.$bvModal.show('modal-create')
    },

    async exportDevice() {
      this.isLoading = true
      const queryParameter = {
        filters: 'companyName:notilike:McEasy Default',
        sorts: 'vehicle_id desc',
        search: this.filter,
      }
      const getExport = await vsmsAxios
        .get('/vehicle-status/export', {
          responseType: 'blob',
          headers: {
            'Accept-Language': process.env.VUE_APP_I18N_LOCALE,
          },
          params: queryParameter,
        })
        .catch((err) => {
          this.handleError(err)
          this.isLoading = false
        })

      const url = window.URL.createObjectURL(getExport?.data)
      const a = document.createElement('a')
      a.href = url
      a.download = 'QcDevice.xlsx'
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(url)
      this.isLoading = false
    },

    getSyncIccidPayload(filters) {
      return {
        status: 'waiting',
        filter: JSON.stringify({
          filters,
        }),
        server_region: 'SG',
        retry: 0,
        action: 'Sync Iccid Perangkat',
      }
    },

    async requestSyncIccid() {
      this.isLoading = true
      const payload = this.getSyncIccidPayload(['company_id eq 1'])

      try {
        await smsAxios.post('/device/sync/iccid', payload)
        this.$toast.success('Request sync ICCID berhasil dikirim')
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
      }
    },

    async requestSyncIccidByImei(item) {
      const imei = item?.vehicle?.imei

      if (!imei) {
        this.$toast.error('IMEI tidak ditemukan')
        return
      }

      const payload = this.getSyncIccidPayload(["imei eq '" + imei + "'"])

      try {
        await smsAxios.post('/device/sync/iccid', payload)
        this.$toast.success('Request sync ICCID untuk IMEI ' + imei + ' berhasil dikirim')
      } catch (error) {
        this.handleError(error)
      }
    },

    async checkIccidStatus(source = 'form') {
      this.resetIccidCheckStatus()
      const target = this[source] || this.form
      const phoneNoValidation = this.$v[source]?.phoneNo

      if (!target.phoneNo) {
        phoneNoValidation?.$touch()
        return
      }

      phoneNoValidation?.$touch()
      if (phoneNoValidation?.$invalid) return

      const payload = {
        phone_no: target.phoneNo,
        iccid: target.iccid,
        imei: target.imei,
      }

      if (!payload.iccid) {
        this.iccidCheckStatus = 'missing'
        return
      }

      this.isCheckingIccid = true
      try {
        const response = await smsAxios.post('/device/iccid/check', payload)
        this.iccidCheckResult = response.data?.data || null
        if (this.iccidCheckResult?.valid) {
          this.iccidCheckStatus = 'valid'
        } else {
          this.iccidCheckStatus = 'invalid'
        }
      } catch (error) {
        this.iccidCheckResult = error.response?.data?.data || null
        this.iccidCheckStatus = 'invalid'
      } finally {
        this.isCheckingIccid = false
      }
    },

    resetIccidCheckStatus() {
      this.iccidCheckStatus = null
      this.iccidCheckResult = null
    },

    iccidStatusLabel() {
      const iccid = this.iccidCheckResult?.iccid || this.form.iccid || this.set.iccid || '-'
      const currentPhoneNo = this.iccidCheckResult?.current_phone_no
      const lastIccidUpdate = this.iccidCheckResult?.last_iccid_update || '-'

      switch (this.iccidCheckStatus) {
        case 'missing':
          return this.$t('qcdevice.incomming.iccidMissing')
        case 'invalid':
          if (currentPhoneNo) {
            return `ICCID device ${iccid} terdaftar pada ${currentPhoneNo} - tidak cocok pada nomor ini`
          }
          return `ICCID device ${iccid} - tidak cocok pada device ini`
        case 'valid':
          return `Cocok dengan ICCID ${iccid} - response terakhir ${this.momentYmDHms(lastIccidUpdate)}`
        default:
          return ' - '
      }
    },

    iccidStatusVariantClass() {
      return this.iccidCheckStatus === 'valid' ? 'text-success' : 'text-warning'
    },

    isIccidInvalid() {
      return this.iccidCheckStatus === 'invalid'
    },

    hasIccid(item) {
      return Boolean(item?.vehicle?.device?.iccid || item?.iccid)
    },

    hasIccidWarning(item) {
      const isIccidValid = item?.vehicle?.device?.is_iccid_valid ?? item?.is_iccid_valid
      return this.hasIccid(item) && isIccidValid === false
    },

    getPhoneNoIconClass(item) {
      if (!this.hasIccid(item)) {
        return 'icon-outline_minus-circle text-muted'
      }

      if (this.hasIccidWarning(item)) {
        return 'fas fa-exclamation-triangle text-warning'
      }

      return 'fas fa-check-circle text-success'
    },

    getVehicleStatusRowClass(item) {
      return this.hasIccidWarning(item) ? 'table-warning' : ''
    },

    getIccidLabel(item) {
      if (!this.hasIccid(item)) {
        return this.$t('qcdevice.incomming.iccidNotReadYet')
      }

      return item?.vehicle?.device?.iccid || item?.iccid
    },

    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value
    },

    nextSetup(item) {
      localStorage.setItem('device', JSON.stringify(item))
      const routeData = this.$router.resolve({
        name: 'Setting Device',
      })
      window.open(routeData.href, '_blank')
    },

    toggleAll(checked, param) {
      this.selectedModel[param] = []
      this.selected[param] = []
      if (checked) {
        for (let i = 0; i < this.vehicleStatuses.vehicleStatuses.length; i++) {
          this.selected[param].push(i)
          this.selectedModel[param].push(true)
        }
      } else {
        for (let i = 0; i < this.vehicleStatuses.vehicleStatuses.length; i++) {
          this.selectedModel[param].push(false)
        }
        this.selected[param] = []
      }
    },

    checkTable(event, data, param) {
      if (event) {
        this.selected[param].push(data)
      } else {
        var myIndex = this.selected[param].indexOf(data)
        if (myIndex !== -1) {
          this.selected[param].splice(myIndex, 1)
        }
      }
    },

    toDelete() {
      let promises = []
      for (let i = 0; i < this.selected.tracking.length; i++) {
        promises.push(
          this.$apollo.mutate({
            mutation: DEVICE_MUTATION_DELETE,
            variables: {
              imei: this.selected.tracking[i].imei,
            },
          })
        )
      }

      Promise.all(promises).then(() => {
        this.getVehicleStatus()
        this.clearDelete()
        this.$toast.success(`Data berhasil dihapus`)
      })
    },

    async setTo(item) {
      this.set = {
        deviceName: item.vehicle.device.device_name,
        vendorType: item.vehicle.device.vendor_type,
        imei: item.vehicle.imei,
        phoneNo: item.vehicle.device.phone_no,
        iccid: item.vehicle.device.iccid,
        vehicleId: item.vehicle_id,
      }
      this.$bvModal.show('device-setup')
      await this.checkIccidStatus('set')
    },

    async registerToCompany() {
      this.saveLoading = true
      this.$v.set.$touch()
      if (this.$v.set.$error) {
        this.saveLoading = false
        return
      }

      let input = {
        company_id: this.set.companies.id,
        year: parseInt(this.set.vehicleYear),
        status: 'I',
        vehicle_type_id: this.set.selectedVehicleType.vehicle_type_id,
        phone_no: this.set.phoneNo,
        license_plate: this.set.selectedVehicle.license_plate,
        odometer: parseInt(this.set.odometer) * 1000,
        hull_no: this.set.hullNo,
        imei: this.set.imei,
        wo: this.set.workOrderNumber,
        reason: this.set.notes,
      }

      const response = await vehicleSmsApi.assignDevice(input, this.set.selectedVehicle.vehicle_id)
      if (response.status) {
        this.$mcToast.success("Device berhasil di pasangkan ke kendaraan customer")
      }
      this.getVehicleStatus()
      this.getIccidStatusSummary()
      this.saveLoading = false
      this.$bvModal.hide('device-setup')
    },

    async onRowClicked(item) {
      this.showDeviceType = false
      this.isEdit = true
      this.formStatus = 'update'
      this.$bvModal.show('modal-create')
      this.form = {
        deviceTypes: item.vehicle.device,
        imei: item.vehicle.imei,
        vehicleId: item.vehicle_id,
        phoneNo: item.vehicle.device.phone_no,
        iccid: item.vehicle.device.iccid,
      }
      this.formOld = {
        deviceTypes: item.vehicle.device.device_code,
        imei: item.vehicle.imei,
        vehicleId: item.vehicle_id,
        phoneNo: item.vehicle.device.phone_no,
        iccid: item.vehicle.device.iccid,
      }
      await this.checkIccidStatus()
      
      this.sensors = await this.getSensors(item.vehicle_id)
    },

    clearDelete() {
      this.allSelected.tracking = false
      this.selectedModel.tracking = []
      this.selected.tracking = []
    },

    resetModal() {
      this.resetIccidCheckStatus()
      this.form = {
        vehicleId: null,
        deviceTypes: null,
        imei: null,
        phoneNo: null,
        iccid: null,
      }

      this.formStatus = 'create'
      this.accordionVisible = false
    },

    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },

    submitImei(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault()
      this.$v.form.$touch()
      if (this.$v.form.$error) return
      // Trigger submit handler
      if (this.isEdit) {
        this.updateDevice()
      } else {
        this.prosesSubmit()
      }
    },

    async updateDevice() {
      let input = {
        device_code: this.form.deviceTypes.deviceCode,
        phone_no: this.form.phoneNo,
      }

      if (this.formOld.imei != this.form.imei) {
        input.imei = this.form.imei
      }

      
      const processUpdateDevice = async () => {
        toolsAxios
          .patch('/device/' + this.formOld.imei, input)
          .then(() => {
            this.formOld.deviceTypes = this.form.deviceTypes
            this.formOld.phoneNo = this.form.phoneNo
            this.getVehicleStatus()
            this.getIccidStatusSummary()
            this.$toast.success('Berhasil diubah')
            this.$bvModal.hide('modal-create')
            this.showDeviceType = false
          })
          .catch((err) => {
            this.handleError(err)
          })
      }

      if (
        this.sensors && 
        this.sensors.length > 0 && 
        this.form.deviceTypes?.device_code !== this.formOld.deviceTypes
      ) {
        this.$bvModal
          .msgBoxConfirm(
            'Device telah memiliki sensor yang terpasang, sensor akan dihapus saat Anda menyimpan perubahan ini. Lanjutkan?',
            {
              title: 'Konfirmasi',
              okVariant: 'primary',
              okTitle: 'Ya',
              cancelTitle: 'Tidak',
              cancelVariant: 'outline-primary',
              centered: true,
            }
          )
          .then(async (value) => {
            if (value) {
              await processUpdateDevice()
            }
          })
      } else {
        await processUpdateDevice()
      }
    },

    respModal(data) {
      this.getVehicleStatus()
      this.$toast.success(`IMEI "` + data.imei + `" Berhasil di daftarkan `)
      this.$root.$emit('bv::toggle::collapse', 'accordion-3')
      setTimeout(() => {
        if (!this.accordionVisible) {
          this.$root.$emit('bv::toggle::collapse', 'accordion-3')
        }
      }, 500)

      this.responseModal.vehicleId = data.vehicle_id
      this.responseModal.imei = data.imei
      this.responseModal.status = 'Register Success'
    },

    checkStatus() {
      this.responseModal.title = 'Cek Status Perangkat'
      this.$root.$emit('bv::toogle::collapse', 'accordion-3')
    },

    checkVersion() {
      this.responseModal.title = 'Cek Versi Perangkat'
      this.$root.$emit('bv::toogle::collapse', 'accordion-3')
    },

    checkLast() {
      this.responseModal.title = 'Cek Data Terakhir'
      this.$root.$emit('bv::toogle::collapse', 'accordion-3')
    },

    async prosesSubmit() {
      let payload = {
        imei: this.form.imei,
        device_code: parseInt(this.form.deviceTypes.deviceCode),
        phone_no: this.form.phoneNo,
      }

      const response = await deviceApi.create(payload)
      if (response.status) {
        const params = {
          filters: [`imei eq '${this.form.imei}'`]
        }
        const devicesResponse = await deviceApi.get(params)
        if (devicesResponse.status) {
          this.respModal(devicesResponse.data.paginated_result[0])
        }
      }
    },

    isDeviceCodeMatched(inputDeviceCode, ERPDeviceCode) {
      if (inputDeviceCode == ERPDeviceCode || (inputDeviceCode === 1006 && ERPDeviceCode === 1003))
        return ERPDeviceCode
    },

    async checkIMEIinERP(imei) {
      const res = await smsAxios.get(`/erp/imei-check-erp?imei=${imei}`)
      return res?.data
    },

    async getSensors(vehicleId) {
      const params = {
        page: 1,
        limit: 1,
        filters: [
          `vehicle_id eq ${vehicleId}`,
          'sensor_code neq 6',
          'sensor_code neq 38',
        ]
      }
      const res = await smsAxios.get('/vehicle/sensor', { params })
      return res?.data?.data?.paginated_result
    },

    handleError(error) {
      if (error.response) {
        const errorStatus = error.response.status
        const errorData = error.response.data

        if (errorStatus === 400 && errorData.message) {
          if (errorData.message === 'license plate is already registered to another vehicle') {
            this.$toast.error(this.$t('setting.error.duplicateLicensePlate'))
            return
          }
        }

        if (errorStatus === 400 && errorData.details) {
          errorData.details.forEach((element) => {
            this.$toast.error(`${errorData.error}: ${element.field} ${element.message}`)
          })
        } else if (errorStatus === 401) {
          this.$toast.error(errorData.error)
          localStorage.removeItem('token')
          localStorage.removeItem('tokenAccess')
          this.$router.push({ name: 'Login' })
        } else if (errorStatus === 403) {
          this.$toast.error(errorData.error)
        } else if (errorStatus === 409) {
          if (errorData.details) {
            errorData.details.forEach((element) => {
              this.$toast.error(`${element.message}`)
            })
          } else {
            this.$toast.error(errorData.message)
          }
        } else {
          this.$toast.error(errorData.error)
        }
      } else if (error.request) {
        this.$toast.error(error.response?.statusText)
      } else {
        this.$toast.error(error.message)
      }
    },

    handleSubmit() {
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modal-create')
        this.resetModal()
      })
    },

    changeStatus(status) {
      this.status = status
      if (this.selected.tracking.length > 0) {
        this.showModal = true
      } else {
        this.$toast.error(`Minimal memilih satu atau lebih dari data di bawah.`)
      }
    },

    toChangeStatus() {
      let promises = []
      for (let i = 0; i < this.selected.tracking.length; i++) {
        promises.push(
          this.$apollo.mutate({
            mutation: DEVICE_MUTATION_UPDATE,
            variables: {
              input: {
                imei: this.selected.tracking[i].imei,
                status: this.status == 'Aktif' ? 0 : 2,
              },
            },
          })
        )
      }

      Promise.all(promises).then(() => {
        this.$toast.success(`Berhasil mengubah ${this.selected.tracking.length} status pelacak.`)
        this.showModal = false
        this.getVehicleStatus()
        this.clearDelete()
      })
    },

    customLabel(item) {
      return `${item.name} (${item.domainName})`
    },

    customLabelDevice(item) {
      if (item.deviceName) return `${item.deviceName}`
    },

    showDeviceTypes() {
      this.showDeviceType = true
      const interval = setInterval(() => {
        this.$refs.deviceTypeRef.isOpen = true
        if (this.$refs.deviceTypeRef) clearInterval(interval)
      }, 100)
    },

    changePage(newPage) {
      this.currentPage = newPage
      this.getVehicleStatus()
    },

    resetFilter(e) {
      this.currentPage = 1
      this.perPage = e
      this.getVehicleStatus()
    },

    buildImeiFilter(imeis) {
      if (!imeis.length) return null

      return imeis.map((imei) => `imei in '${imei.replace(/'/g, "\\'")}'`)
    },

    getIccidStatusCount(status) {
      const summaryKeyByStatus = {
        valid: 'total_valid',
        invalid: 'total_invalid',
        iccid_not_found: 'iccid_not_found',
      }

      const summaryKey = summaryKeyByStatus[status] || 'total_data'
      return this.iccidStatusSummary[summaryKey] || 0
    },

    onIccidStatusFilterChange(status) {
      this.selectedIccidStatusFilter = status
      this.currentPage = 1
      this.getVehicleStatus()
    },

    onImeiFilterChange(imeis) {
      this.appliedImeiFilters = imeis
      this.currentPage = 1
      this.getVehicleStatus()
      this.getIccidStatusSummary()
    },

    searchData: debounce(function () {
      this.currentPage = 1
      this.getVehicleStatus()
      this.getIccidStatusSummary()
    }, 600),

    onImeiChange(e) {
      let self = this
      clearTimeout(self.debounceTimer)
      self.debounceTimer = setTimeout(async () => {
        const IMEIFromERP = await this.checkIMEIinERP(e)
        if (IMEIFromERP?.device_code) {
          const deviceName = this.deviceTypes?.deviceType.find(
            (e) => e.deviceCode == IMEIFromERP.device_code
          ).deviceName
          this.form.deviceTypes = {
            deviceCode: IMEIFromERP.device_code,
            deviceName: deviceName ?? IMEIFromERP.device_name,
          }
        } else {
          this.form.deviceTypes = null
        }
      }, 300)
    },

    async addVehicleTag(newValue) {
      const tag = {
        license_plate: newValue,
        vehicle_id: this.set.vehicleId,
        vehicle_type_id: 0,
        odometer: this.set.odometer,
        hullNo: this.set.hullNo,
      }
      this.set.selectedVehicle = tag
      this.vehicles.push(tag)
      const params = {
        filters: [`company_id eq 1`],
        limit: 1,
      }
      const responseLimit1 = await vehicleApi.getVehicleType(params)
      const totalCount = responseLimit1.metadata.total_count
      params.limit = totalCount
      const response = await vehicleApi.getVehicleType(params)
      const vehicleTypes = response.data.paginated_result
      this.vehicleTypes = vehicleTypes
    },

    handleFailedValidation() {
      return
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <p class="mb-4">Proses Mendaftarkan IMEI device ke system untuk pertama kali</p>
    <div class="clearfix mc-btn-group__list">
      <div class="float-end">
        <b-button
          @click="$router.push({ name: 'QC Device' })"
          variant="outline-primary"
          menu-class="dropdown-menu-end"
          class="ms-3"
        >
          <i class="bx bx-arrow-back"></i> {{ $t('global.back') }}
        </b-button>
      </div>
    </div>

    <div
      class="row mb-3"
      v-if="this.getAccessFunc('addNewIMEI') || hasAccessAll('sms-md-company:read')"
    >
      <div class="col-md-6"></div>

      <div class="col-md-6 d-flex justify-content-end gap-2">
        <McButton
          variant="secondary"
          :text="$t('global.bulkSetTo')"
          icon="icon-outline_Pin-History"
          @click="$router.push({ name: 'Device Import Set To Customer' })"
        />
        <McButton
          v-if="$store.state.config.importDevice"
          variant="secondary"
          :text="$t('global.upload')"
          icon="icon-outline_upload"
          @click="$router.push({ name: 'Device Import' })"
        />
        <b-button
          variant="primary"
          type="button"
          @click="exportDevice"
          :disabled="!(vehicleStatuses.vehicleStatuses.length > 0) || isLoading"
        >
          <b-spinner v-if="isLoading" small type="grow"></b-spinner>
          {{ $t('global.export') }}
        </b-button>
        <b-dropdown
          id="sync-dropdown"
          text="Sync Iccid"
          variant="primary"
          right
        >
          <b-dropdown-item
            v-if="hasAccessAll(['sms-sync-iccid:read'])"
            @click="requestSyncIccid"
            :disabled="isLoading"
          >
            <b-spinner
              v-if="isLoading"
              small
              type="grow"
              class="mr-2"
            ></b-spinner>
            Sync ICCID
          </b-dropdown-item>

          <b-dropdown-item 
            v-if="hasAccessAll(['sms-sync-iccid:create'])"
            @click="syncIccidLogModal = true">
            <i class="fas fa-history mr-2"></i>
            Sync ICCID Log
          </b-dropdown-item>
        </b-dropdown>
        <div
          class="mc-table-filter"
          v-if="
            getAccessRight('qcDevice') ||
            hasAccessAll(['sms-device-register:read', 'sms-device-register:create'])
          "
        >
          <a class="popup-form btn btn-primary" href="javascript: void(0);" @click="addDevice">
            <i class="bx bx-plus"></i> {{ $t('global.addField') }}
          </a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="clearfix">
              <div class="float-start">
                <h6 v-if="selected.tracking.length" class="mc-row-check">
                  <span class="badge btn-success">{{ selected.tracking.length }}</span>
                  Baris terpilih.
                  <a class="color-primary" @click="clearDelete">Bersihkan semua</a>
                </h6>
              </div>

              <!-- Search -->
              <div class="float-end">
                <div class="mc-table-view">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end d-flex flex-wrap justify-content-end align-items-center gap-2"
                  >
                    <ImeiFilter
                      :value="appliedImeiFilters"
                      :device-types="deviceTypes.deviceType"
                      @input="onImeiFilterChange"
                      @error="handleError"
                    />
                    <label class="d-inline-flex align-items-center mc-table-view__search ms-2 mb-0">
                      <i class="mc-fa fas fa-search"></i>
                      <b-form-input
                        v-model="filter"
                        type="search"
                        :placeholder="$t('global.search') + '...'"
                        class="ms-2 form-control"
                        @input="searchData"
                      />
                    </label>
                  </div>
                </div>
              </div>
              <!-- End search -->
            </div>

            <div class="mc-iccid-filter d-flex flex-wrap align-items-center gap-2 mt-3">
              <span class="mc-iccid-filter__label">VALIDITAS SIM</span>
              <b-button
                v-for="statusFilter in iccidStatusFilters"
                :key="statusFilter.value || 'total'"
                type="button"
                size="sm"
                pill
                :variant="
                  selectedIccidStatusFilter === statusFilter.value ? 'primary' : 'outline-light'
                "
                class="mc-iccid-filter__button"
                :class="`mc-iccid-filter__button--${statusFilter.variant}`"
                :disabled="isLoading && selectedIccidStatusFilter !== statusFilter.value"
                @click="onIccidStatusFilterChange(statusFilter.value)"
              >
                <i v-if="statusFilter.icon" :class="statusFilter.icon"></i>
                <span>{{ statusFilter.label }}</span>
                <strong>{{ getIccidStatusCount(statusFilter.value) }}</strong>
              </b-button>
            </div>

            <div class="table-responsive mb-0 my-3 border border-1">
              <b-table
                class="datatables"
                :items="vehicleStatuses.vehicleStatuses"
                :fields="visibleFields"
                show-empty
                :empty-text="$t('global.emptyTable')"
                :empty-filtered-text="$t('global.emptyFilteredTable')"
                :per-page="perPage"
                @row-clicked="onRowClicked"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                :busy="isLoading"
                :tbody-tr-class="getVehicleStatusRowClass"
                @hidden="resetModal"
              >
                <template #head(last_receive)="data">
                  <p>
                    {{ data.label }}
                    <i id="status-header-icon" class="mc-fa icon-fill_info"></i>

                    <b-tooltip target="status-header-icon" triggers="hover" placement="bottom">
                      <p class="mb-0">{{ $t('vehicle.status.lastReceiveTooltip') }}</p>
                    </b-tooltip>
                  </p>
                </template>
                <template #head(last_position_status)="data">
                  <p>
                    {{ data.label }}
                    <i id="status-change-header-icon" class="mc-fa icon-fill_info"></i>

                    <b-tooltip
                      target="status-change-header-icon"
                      triggers="hover"
                      placement="bottom"
                    >
                      <p class="mb-0">{{ $t('vehicle.status.lastStatusChgTooltip') }}</p>
                    </b-tooltip>
                  </p>
                </template>
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <template #head(columnCheck)>
                  <div class="form-check">
                    <b-form-checkbox
                      @change="toggleAll($event, 'tracking')"
                      v-model="allSelected.tracking"
                      :indeterminate="indeterminate.tracking"
                      :value="true"
                      :unchecked-value="false"
                      :disabled="!getAccessRight()"
                    ></b-form-checkbox>
                  </div>
                </template>
                <template #cell(columnCheck)="data">
                  <div class="form-check">
                    <b-form-checkbox
                      @change="checkTable($event, data.item, 'tracking')"
                      v-model="selectedModel.tracking[data.index]"
                      :value="true"
                      :unchecked-value="false"
                      :disabled="!getAccessRight()"
                    ></b-form-checkbox>
                  </div>
                </template>
                <template #cell(vehicle.imei)="data">
                  <strong class="text-primary" @click="onRowClicked(data.item)">
                    {{ data.item.vehicle.imei }}
                  </strong>
                </template>
                <template #cell(vehicle.device.phone_no)="data">
                  <span>
                    <i
                      :class="getPhoneNoIconClass(data.item)"
                      class="me-2"
                    ></i>
                    {{ data.item?.vehicle?.device?.phone_no || data.item?.phone_no || '-' }}
                  </span>
                </template>
                <template #cell(vehicle.device.iccid)="data">
                  {{ getIccidLabel(data.item) }}
                </template>
                <template #cell(last_receive)="data">
                  {{ data.item.last_receive ? momentDMHGmt7(data.item.last_receive) : '-' }}
                </template>
                <template #cell(last_position_status)="data">
                  {{ data.item.last_position_status ? momentDMHGmt7(data.item.last_position_status) : '-' }}
                </template>
                <template #cell(setCustomer)="data">
                  <div class="button-items" style="text-align: center">
                    <b-button
                      id="tooltip-set-to"
                      :class="
                        getAccessRight('qcDevice') ||
                        hasAccessAll(['sms-device-register:update', 'sms-device-register:read'])
                      "
                      variant="me-3 btn-outline-primary"
                      @click="setTo(data.item)"
                    >
                      Set to
                    </b-button>
                    <b-tooltip
                      target="tooltip-set-to"
                      placement="top"
                      title="Daftarkan Ke Customer"
                    >
                    </b-tooltip>
                  </div>
                </template>
                <template #cell(syncIccid)="data">
                  <div class="button-items" style="text-align: center">
                    <b-button
                      variant="me-3 btn-outline-primary"
                      @click.stop="requestSyncIccidByImei(data.item)"
                      v-b-tooltip.hover.top="'Sync ICCID'"
                    >
                      <i class="fas fa-sync-alt"></i>
                    </b-button>
                  </div>
                </template>
              </b-table>
            </div>

            <div class="row mt-3">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    <span>Menampilkan</span>
                    <span>
                      <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                        @change="resetFilter"
                      />
                    </span>
                    <span>entri.&nbsp;&nbsp;</span>
                    <span
                      >Menampilkan&nbsp;
                      <strong>
                        {{ filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0 }}
                      </strong>
                      &nbsp;sampai&nbsp;
                      <strong>
                        {{
                          currentPage != totalPages
                            ? currentPage * perPage
                            : (currentPage - 1) * perPage + filteredItems.length
                        }}
                      </strong>
                      &nbsp;dari&nbsp;
                      <strong>{{ totalRows }}</strong>
                      &nbsp;entri.
                    </span>
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      @change="changePage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Create -->
    <b-modal
      id="device-setup"
      ref="device-setup"
      size="lg"
      title="Set Pelacak"
      @hidden="resetModal"
      centered
    >
      <b-row>
        <!-- IMEI -->
        <b-col md="3">
          <div class="mb-3">
            <span class="d-block">IMEI</span>
            <strong>{{ set.imei }}</strong>
          </div>
        </b-col>

        <!-- Vendor -->
        <b-col md="2">
          <div class="mb-3">
            <span class="d-block">Vendor</span>
            <strong>{{ set.vendorType }}</strong>
          </div>
        </b-col>

        <!-- Tipe Perangkat -->
        <b-col md="2">
          <div class="mb-3">
            <span class="d-block">Device</span>
            <strong>{{ set.deviceName }}</strong>
          </div>
        </b-col>
      </b-row>
      <FormulateForm
        v-model="set"
        @submit="registerToCompany"
        :errors="formErrors"
        @failed-validation="handleFailedValidation"
      >
        <div class="mb-2">
          <label class="required">{{ $t('setting.modal.targetCompany') }}</label>
          <multiselect
            v-model="set.companies"
            :options="companies.companies"
            placeholder="Pilih Company"
            :custom-label="customLabel"
            :class="{
              'is-invalid': $v.set.companies.$error,
            }"
            @input="onCompanySelect"
          />
          <div v-if="$v.set.companies.$error" class="invalid-feedback mt-0">
            <span v-if="!$v.set.companies.required">
              {{ $t('setting.modal.targetCompany') }} Wajib Terisi
            </span>
          </div>
        </div>

        <div class="mb-2">
          <label class="required" for="newLicensePlate">
            {{ $t('setting.modal.newLicensePlate') }}
          </label>
          <multiselect
            v-model="set.selectedVehicle"
            :options="filteredVehicles"
            label="license_plate"
            track-by="vehicle_id"
            placeholder="Pilih Kendaraan"
            @input="onVehicleSelect"
            :taggable="true"
            @tag="addVehicleTag"
            :class="{
              'is-invalid': $v.set.selectedVehicle.$error,
            }"
          />
          <div v-if="$v.set.selectedVehicle.$error" class="invalid-feedback mt-0">
            <span v-if="!$v.set.selectedVehicle.required">
              {{ $t('setting.modal.newLicensePlate') }} Wajib Terisi
            </span>
          </div>
        </div>

        <div class="mb-2">
          <label class="required" for="vehicleType">{{ $t('setting.modal.vehicleType') }}</label>
          <multiselect
            v-model="set.selectedVehicleType"
            :options="filteredVehicleTypes"
            label="vehicle_type"
            track-by="vehicle_type_id"
            placeholder="Pilih Jenis Kendaraan"
            :class="{
              'is-invalid': $v.set.selectedVehicleType.$error,
            }"
          />
          <div v-if="$v.set.selectedVehicleType.$error" class="invalid-feedback mt-0">
            <span v-if="!$v.set.selectedVehicleType.required">
              {{ $t('setting.modal.vehicleType') }} Wajib Terisi
            </span>
          </div>
        </div>

        <div class="mb-2">
          <label class="required" for="vehicleType">{{ $t('setting.modal.newSimcard') }}</label>
          <FormulateInput
            type="number"
            v-model="set.phoneNo"
            name="phoneNo"
            placeholder="Ganti dengan Simcard baru"
            :class="{
              'mc-formulate--iccid-invalid': isIccidInvalid() && !$v.set.phoneNo.$error,
            }"
            :validation="['required', 'phone']"
            :validation-messages="{
              required: `${$t('setting.modal.newSimcard')} Wajib Terisi`,
              phone: `${$t('qcdevice.incomming.invalidPhoneNumber')}`,
            }"
            validation-behavior="live"
            error-behavior="live"
            @input="checkIccidStatus('set')"
            @keydown="portKeydown($event, (preventZeroFirst = true))"
          />
          <div class="w-100 d-flex justify-content-between">
            <small
              v-if="iccidCheckStatus"
              class="d-block mt-1"
              :class="iccidStatusVariantClass()"
            >
              {{ iccidStatusLabel() }}
            </small>
            <b-button
              v-b-tooltip.hover.top="'Cek ulang status iccid'"
              type="button"
              variant="icon"
              :disabled="isCheckingIccid"
              @click="checkIccidStatus('set')"
            >
              <b-spinner v-if="isCheckingIccid" small />
              <i v-else class="fas fa-sync-alt"></i>
            </b-button>
          </div>
        </div>

        <div class="mb-2">
          <label class="required" for="vehicleType">Odometer</label>
          <FormulateInput
            type="number"
            v-model="set.odometer"
            name="odometer"
            placeholder="Masukkan Odometer (Km)"
            validation-behavior="live"
            error-behavior="live"
            :validation="['required']"
            :validation-messages="{
              required: `Odometer Wajib Terisi`,
            }"
            mt="2"
            @keydown="portKeydown($event)"
          />
        </div>

        <FormulateInput
          type="number"
          v-model="set.vehicleYear"
          name="vehicleYear"
          label="Tahun Kendaraan"
          placeholder="Masukkan Tahun Kendaraan"
          mt="2"
          @keydown="portKeydown($event)"
        />

        <FormulateInput
          type="text"
          v-model="set.hullNo"
          name="hullNo"
          label="Nomor Lambung"
          placeholder="Masukkan Nomor Lambung"
          mt="2"
        />

        <div v-if="isDeviceStatusProcessActive" class="mt-2 mb-3">
          <label class="required">Nomor Work Order atau Ticket untuk sumber data</label>
          <b-form-input
            v-model="set.workOrderNumber"
            type="text"
            placeholder="input nomor WO, tiket jira, atau link freshdesk"
            :class="{
              'is-invalid': $v.set.workOrderNumber.$error,
            }"
          />
          <div v-if="$v.set.workOrderNumber.$error" class="invalid-feedback mt-0">
            <span v-if="!$v.set.workOrderNumber.required">
              Wo Wajib Terisi
            </span>
          </div>
        </div>

        <div v-if="isDeviceStatusProcessActive" class="mb-3">
          <label class="required">Catatan / Alasan Proses</label>
          <b-form-textarea
            v-model="set.notes"
            placeholder="Jelaskan alasan melakukan proses ini..."
            rows="3"
            :class="{
              'is-invalid': $v.set.notes.$error,
            }"
          />
          <div v-if="$v.set.notes.$error" class="invalid-feedback mt-0">
            <span v-if="!$v.set.notes.required">
              Alasan Wajib Terisi
            </span>
            <span v-else-if="!$v.set.notes.minLength">
              Reason must have at least 10 characters
            </span>
          </div>
        </div>

      </FormulateForm>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer">
          <b-col sm="12" md="8" class="mc-modal__filter-footer-fav"> </b-col>
          <b-col sm="12" md="4" class="mc-modal__filter-footer-btn">
            <b-button
              :disabled="saveLoading"
              variant="outline-primary"
              @click="cancel"
              class="me-3"
            >
              Batal
            </b-button>
            <b-button
              :disabled="saveLoading"
              type="submit"
              variant="primary"
              @click="registerToCompany"
            >
              <b-spinner v-if="saveLoading" small />
              Simpan
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <b-modal
      class="mc-modal"
      id="modal-create"
      :title="isEdit ? 'Perubahan Data Device' : 'Registrasi IMEI'"
      size="lg"
      centered
      scrollable
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" class="mc-form" @submit.stop.prevent="handleSubmit">
        <b-row>
          <!-- Tracking ID -->
          <b-col md="12">
            <div class="mb-3 mc-input-info">
              <label class="mt-3 required">IMEI</label>
              <b-form-input
                id="imei"
                placeholder="Masukkan IMEI yang akan didaftarkan"
                v-model="form.imei"
                type="number"
                :class="{
                  'is-invalid': $v.form.imei.$error,
                }"
                trim
                @input="onImeiChange"
                @keydown="portKeydown($event, (preventZeroFirst = true), (preventComma = true))"
                :disabled="isEdit && !hasAccessAll('update-imei:update')"
              >
              </b-form-input>
              <div v-if="$v.form.imei.$error" class="invalid-feedback">
                <span v-if="!$v.form.imei.required"> IMEI Wajib Terisi </span>
              </div>
            </div>
            <div class="mb-3 mc-input-info">
              <b-form-group
                id="phoneNo_label"
                label="Nomor SIMCard"
                label-for="phoneNo"
                label-class="required"
              >
                <b-input-group>
                  <b-form-input
                    id="phoneNo"
                    placeholder="Nomor SIMCard"
                    type="number"
                    v-model="form.phoneNo"
                    trim
                    :class="{
                      'is-invalid': $v.form.phoneNo.$error,
                      'mc-phone-input--iccid-invalid': isIccidInvalid() && !$v.form.phoneNo.$error,
                    }"
                    @input="checkIccidStatus"
                    @keydown="portKeydown($event, (preventZeroFirst = true))"
                  />
                </b-input-group>
                <div v-if="$v.form.phoneNo.$error" class="invalid-feedback">
                  <span v-if="!$v.form.phoneNo.required">
                    {{ $t('setting.form.simcard') }} Wajib Terisi
                  </span>
                  <span v-else-if="!$v.form.phoneNo.isIndonesianPhoneNumber">
                    {{ $t('qcdevice.incomming.invalidPhoneNumber') }}
                  </span>
                </div>
                <div class="w-100 d-flex justify-content-between">
                  <small
                    v-if="iccidCheckStatus"
                    class="d-block mt-1"
                    :class="iccidStatusVariantClass()"
                  >
                    {{ iccidStatusLabel() }}
                  </small>
                  <b-button
                    v-b-tooltip.hover.top="'Cek ulang status iccid'"
                    type="button"
                    variant="icon"
                    :disabled="isCheckingIccid"
                    @click="checkIccidStatus"
                  >
                    <b-spinner v-if="isCheckingIccid" small />
                    <i v-else class="fas fa-sync-alt"></i>
                  </b-button>
                </div>
              </b-form-group>
            </div>
            <div class="mb-2">
              <label class="required">Tipe Perangkat</label>
              <b-form-input
                v-if="!showDeviceType"
                id="deviceType"
                :value="form.deviceTypes?.device_name ?? form.deviceTypes?.deviceName"
                trim
                @click="showDeviceTypes"
              />
              <multiselect
                v-else
                id="deviceTypeSelect"
                ref="deviceTypeRef"
                v-model="form.deviceTypes"
                :options="deviceTypes.deviceType"
                label="deviceName"
                placeholder="Tipe Perangkat"
                :class="{
                  'is-invalid': $v.form.deviceTypes.$error,
                }"
                :allow-empty="false"
                open-direction="top"
                :custom-label="customLabelDevice"
              />
              <div v-if="$v.form.deviceTypes.$error" class="invalid-feedback">
                <span v-if="!$v.form.deviceTypes.required">
                  {{ $t('setting.form.deviceType') }} Wajib Terisi
                </span>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-button variant="primary" v-if="!isEdit" @click="submitImei"> Daftarkan IMEI </b-button>
        <b-button variant="primary" v-if="isEdit" @click="submitImei">
          {{ $t('global.saveChanges') }}
        </b-button>
        <b-row class="modal-body"><b-col md="12"></b-col></b-row>
        <b-collapse
          id="accordion-3"
          v-model="accordionVisible"
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card no-body>
            <template #header>
              <h4 class="mb-0">{{ responseModal.title }}</h4>
            </template>
            <b-list-group flush>
              <b-list-group-item>IMEI : {{ responseModal.imei }}</b-list-group-item>
              <b-list-group-item>Vehicle ID : {{ responseModal.vehicleId }}</b-list-group-item>
              <b-list-group-item style="color: #07a76d; font-weight: bold"
                >Status : {{ responseModal.status }}</b-list-group-item
              >
            </b-list-group>
          </b-card>
        </b-collapse>
      </form>

      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer">
          <b-col sm="12" md="6" class="mc-modal__filter-footer-fav">
            <div class="button-items"></div>
          </b-col>
          <b-col sm="12" md="6" class="mc-modal__filter-footer-btn">
            <b-button
              variant="outline-primary"
              @click="nextSetup(form)"
              class="me-3"
              :disabled="!form.imei"
            >
              <i class="mc-fa icon-fill_keypad"></i>
              Konfigurasi lebih lanjut
            </b-button>
            <b-button variant="outline-primary" @click="cancel()" class="me-3">
              <i class="mc-fa icon-outline_close"></i>
              Tutup
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Riwayat -->
    <b-modal id="modal-center" centered title="Riwayat" title-class="font-18" hide-footer size="lg">
      <div class="clearfix">
        <div class="float-start"></div>

        <div class="float-end">
          <div id="tickets-table_filter" class="dataTables_filter text-md-end">
            <label class="d-inline-flex align-items-center mc-table-view__search">
              <i class="mc-fa fas fa-search"></i>
              <b-form-input
                v-model="filterHistory"
                type="search"
                :placeholder="$t('global.search') + '...'"
                class="form-control"
              />
            </label>
          </div>
        </div>
      </div>

      <!-- Table Riwayat -->
      <div class="table-responsive mb-0">
        <b-table
          small
          show-empty
          :fields="listHistory"
          :items="tData.listHistory"
          class="datatables mt-3 border border-1"
          responsive="sm"
          empty-table
          :empty-text="$t('global.emptyTable')"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filterHistory"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
        </b-table>
      </div>
    </b-modal>

    <!-- Status -->
    <b-modal
      v-model="showModal"
      title="Ubah Status"
      body-class="p-3"
      hide-footer
      size="md"
      centered
    >
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <p>
            Apakah anda yakin mengubah status data berikut menjadi
            <b>{{ status }}</b> ?
          </p>

          <div class="table-responsive">
            <table class="table table-bordered mb-0">
              <thead>
                <tr></tr>
              </thead>
              <tbody>
                <tr v-for="device in selected.tracking" :key="device.imei">
                  <td>{{ device.identifier }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="text-end pt-5 mt-3">
          <b-button variant="outline-primary" @click="showModal = false">Tidak</b-button>
          <b-button type="submit" variant="primary" class="ms-2" @click="toChangeStatus"
            >Ya</b-button
          >
        </div>
      </form>
    </b-modal>

    <!-- Filter -->
    <b-modal class="mc-modal" id="modal-filter" title="Filter" size="lg" centered scrollable>
      <div class="card-body mc-modal__filter">
        <form>
          <div class="mc-modal__filter-item">
            <b-form-group label="Status" v-slot="{ ariaDescribedby }">
              <b-form-checkbox-group
                id="checkbox-group-1"
                v-model="selected"
                :options="['Aktif']"
                :aria-describedby="ariaDescribedby"
                name="flavour-1"
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
          <div class="mc-modal__filter-item">
            <label class="mt-3">Vendor</label>
            <multiselect
              v-model="vendor"
              :options="['McEasy', 'EasyGo', 'Foxlogger', 'Other', 'Tidak Berkategori']"
              :multiple="true"
              placeholder="Vendor"
            ></multiselect>
          </div>
          <div class="mc-modal__filter-item">
            <label>Tipe Perangkat</label>
            <multiselect
              v-model="tipePerangkat"
              :options="['X100', 'TRV102', 'Concox X3', 'FMB103']"
              :multiple="true"
              placeholder="Tipe Perangkat"
            ></multiselect>
          </div>
          <div class="mc-modal__filter-item">
            <div class="form-check form-switch mb-3">
              <input type="checkbox" id="switchArsip" class="form-check-input" /><label
                for="switchArsip"
                class="form-check-label"
                >Tampilkan Status Arsip</label
              >
            </div>
          </div>
        </form>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer">
          <b-col sm="12" md="8" class="mc-modal__filter-footer-fav">
            <b-row>
              <b-col md="6">
                <b-form-group
                  v-if="!isAddFavorit"
                  id="favorit-label-modal"
                  label="Favorit"
                  label-for="favorit-modal"
                >
                  <multiselect
                    v-model="fav"
                    :options="['Semua Status', 'Status Aktif', 'Status Nonaktif']"
                    :show-labels="false"
                  />
                </b-form-group>
                <b-form-group
                  v-if="isAddFavorit"
                  id="favorit-add-label-modal"
                  label="Favorit"
                  label-for="favorit-modal-add"
                >
                  <b-form-input
                    id="favorit-modal-add"
                    v-model="addFavorit"
                    placeholder="Nama Favorit"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-button
                  v-if="!isAddFavorit"
                  variant="outline-primary"
                  @click="isAddFavorit = !isAddFavorit"
                >
                  <i class="mdi mdi-file-plus-outline"></i> Buat Favorit Baru
                </b-button>
                <b-button v-if="isAddFavorit" variant="outline-primary">
                  <i class="fas fa-save"></i> Simpan Sebagai Favorit
                </b-button>
                <i
                  v-if="isAddFavorit"
                  class="fas fa-trash text-danger text-lg mt-4 ms-3"
                  @click="isAddFavorit = !isAddFavorit"
                ></i>
              </b-col>
            </b-row>
          </b-col>

          <b-col sm="12" md="4" class="mc-modal__filter-footer-btn">
            <b-button variant="outline-primary" @click="cancel()" class="me-3"> Batal </b-button>
            <b-button variant="primary"> Terapkan </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <sync-iccid-log v-if="syncIccidLogModal" :modal.sync="syncIccidLogModal" />
  </Layout>
</template>


<style>
.formulate-input ul.formulate-input-errors {
  font-style: normal;
  font-size: 80%;
}

.mc-iccid-filter {
  column-gap: 0.5rem;
  row-gap: 0.5rem;
}

.mc-iccid-filter__label {
  color: #67718b;
  font-size: 12px;
  font-weight: 700;
}

.mc-iccid-filter__button {
  align-items: center;
  border-color: #e6e7ec;
  display: inline-flex;
  gap: 0.5rem;
  line-height: 1.2;
  min-height: 32px;
  padding: 0.35rem 0.85rem;
}

.mc-iccid-filter__button.btn-outline-light {
  background-color: #fff;
  color: #344264;
}

.mc-iccid-filter__button.btn-outline-light:hover,
.mc-iccid-filter__button.btn-outline-light:focus {
  background-color: #e7ecf4;
  border-color: #cfdae9;
  color: #344264;
}

.mc-iccid-filter__button--valid i {
  color: #137c55;
}

.mc-iccid-filter__button--invalid i {
  color: #ff8a00;
}

.mc-iccid-filter__button--missing i {
  color: #99a1b1;
}

.mc-iccid-filter__button.btn-primary i,
.mc-iccid-filter__button.btn-primary strong,
.mc-iccid-filter__button.btn-primary span {
  color: #fff;
}

.mc-phone-input--iccid-invalid,
.mc-phone-input--iccid-invalid:focus,
.mc-formulate--iccid-invalid:not([data-is-showing-errors='true'])
  .formulate-input-element
  > input {
  border-color: #ff8a00;
}

.mc-phone-input--iccid-invalid:focus,
.mc-formulate--iccid-invalid:not([data-is-showing-errors='true'])
  .formulate-input-element
  > input:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 138, 0, 0.16);
}

</style>
